export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonClasses?: string;
  children: React.ReactNode;
  handleClick?: () => void;
}

export const ButtonBase: React.FC<ButtonProps> = ({
  buttonClasses = "button",
  children,
  handleClick,
  ...props
}) => {
  return (
    <button className={buttonClasses} onClick={handleClick} {...props}>
      {children}
    </button>
  );
};

interface IconButtonProps {
  buttonIcon: string;
  title: string;
}

export const IconButton: React.FC<IconButtonProps> = ({
  buttonIcon,
  title,
  ...props
}) => {
  return (
    <ButtonBase {...props} buttonClasses="button__icon">
      <span>Add {buttonIcon} here!</span>
      <span>Add screen-reader only {title} here!</span>
    </ButtonBase>
  );
};
